var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 15.5244C2.54167 15.5244 2.14917 15.3611 1.8225 15.0344C1.49583 14.7077 1.33278 14.3155 1.33333 13.8577V3.02441H0.5V1.35775H4.66667V0.524414H9.66667V1.35775H13.8333V3.02441H13V13.8577C13 14.3161 12.8367 14.7086 12.51 15.0352C12.1833 15.3619 11.7911 15.525 11.3333 15.5244H3ZM4.66667 12.1911H6.33333V4.69108H4.66667V12.1911ZM8 12.1911H9.66667V4.69108H8V12.1911Z",
    fill: "#F2464B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinIcon);
export default __webpack_public_path__ + "static/media/bin_icon.d51ee26084a6369ff7e38a587aa3db9e.svg";
export { ForwardRef as ReactComponent };